import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";
import { Chip, GlassButton, Segmented } from "@/components/glass/Glass";
import { useCategories } from "@/hooks/useMovies";

export const SORT_OPTIONS = [
  { value: "popular", label: "Mashhur" },
  { value: "new", label: "Yangi" },
  { value: "rating", label: "Reyting" },
  { value: "recent", label: "Qo‘shilgan" },
];
export const TYPE_OPTIONS = [
  { value: "", label: "Hammasi" },
  { value: "movie", label: "Filmlar" },
  { value: "series", label: "Seriallar" },
];

export function FilterSheet({ open, onOpenChange, value, onChange, onReset }) {
  const { data } = useCategories();
  const genres = data?.items || [];
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="border-white/10 bg-[#111114] text-white" data-testid="filter-sheet">
        <div className="mx-auto w-full max-w-2xl px-5 pb-[calc(24px+var(--safe-bottom))] pt-2">
          <DrawerTitle className="text-[20px] font-bold tracking-[-0.01em]">Filtrlar</DrawerTitle>
          <DrawerDescription className="mt-1 text-[13.5px] text-white/55">Natijalarni janr, tur va tartib bo‘yicha saralang.</DrawerDescription>

          <h4 className="mb-2.5 mt-6 text-[13px] font-semibold text-white/60">Tartib</h4>
          <Segmented options={SORT_OPTIONS} value={value.sort || "popular"} onChange={(v) => onChange({ ...value, sort: v })} testId="filter-sort" size="sm" />

          <h4 className="mb-2.5 mt-6 text-[13px] font-semibold text-white/60">Tur</h4>
          <Segmented options={TYPE_OPTIONS} value={value.type || ""} onChange={(v) => onChange({ ...value, type: v })} testId="filter-type" size="sm" />

          <h4 className="mb-2.5 mt-6 text-[13px] font-semibold text-white/60">Janr</h4>
          <div className="flex flex-wrap gap-2">
            <Chip active={!value.genre} onClick={() => onChange({ ...value, genre: "" })} data-testid="filter-genre-all">
              Barchasi
            </Chip>
            {genres.map((g) => (
              <Chip key={g.slug} active={value.genre === g.slug} onClick={() => onChange({ ...value, genre: value.genre === g.slug ? "" : g.slug })} data-testid={`filter-genre-${g.slug}`}>
                {g.name}
              </Chip>
            ))}
          </div>

          <div className="mt-8 flex gap-3">
            <GlassButton variant="ghost" className="flex-1" onClick={onReset} data-testid="filter-reset">
              Tozalash
            </GlassButton>
            <GlassButton variant="primary" className="flex-1" onClick={() => onOpenChange(false)} data-testid="filter-apply">
              Ko‘rsatish
            </GlassButton>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
